






























import Vue from 'vue';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import mixins from 'vue-typed-mixins';
import PermitVehicle from './PermitVehicle';
import PermitVehicleRow from './PermitVehicleRow.vue';
import {Logger} from '@/Shared/Logger';

export default mixins(LocationBasedMixin).extend({
    components: { LocationLookupDropdown, PermitVehicleRow },
    name: 'PermitVehicleForm',
    model: {
        prop: 'value',
        event: 'change'
    },
    props : {
        value: {
            required: true,
            type: Array as () => PermitVehicle[]
        },
        shareQuantity: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            vehicles: this.value,
            addVehicle: {} as PermitVehicle,
            addingVehicle: false
        };
    },
    computed: {
        canAddVehicle(): boolean {
            return this.vehicles.length < this.shareQuantity;
        }
    },
    mounted() {
        if (this.vehicles.length === 0) {
            this.add();
        }
    },
    watch: {
        value(newValue) {
            this.vehicles = newValue;
        },
        vehicles() {
            this.$emit('change', [...this.vehicles]);
        }
    },
    methods: {
        add() {
            this.addVehicle = {} as PermitVehicle;
            this.addingVehicle = true;
        },
        added(vehicle: PermitVehicle) {
            this.vehicles.push(vehicle);

            this.addVehicle = {} as PermitVehicle;
            this.addingVehicle = false;
        },
        deleted(vehicle: PermitVehicle) {
            const index = this.vehicles.findIndex(v => v.vehicleLicense === vehicle.vehicleLicense);

            this.vehicles.splice(index, 1);
        },
        updated(vehicle: PermitVehicle) {
            const index = this.vehicles.findIndex(v => v.vehicleLicense === vehicle.vehicleLicense);

            this.vehicles[index] = vehicle;
        },
        cancelNew() {
            this.addVehicle = {} as PermitVehicle;
            this.addingVehicle = false;
        }
    }
});
